/**
 * Maps GET /quotations/:id response { quotation, items } into Create Job react-hook-form defaults.
 * Only includes fields that exist on the job form; optional / insurance fields are left unset.
 */

function splitCustomerName(full) {
  const s = (full || "").trim();
  if (!s) return { first: "Customer", last: "" };
  const parts = s.split(/\s+/);
  if (parts.length === 1) return { first: parts[0], last: "" };
  return { first: parts[0], last: parts.slice(1).join(" ") };
}

/** Mobile field expects 10 digits — best-effort from quotation phone; empty if unusable. */
function contactDigits10(phone) {
  const d = String(phone || "").replace(/\D/g, "");
  if (d.length >= 10) return d.slice(-10);
  if (d.length > 0) return d.padStart(10, "0").slice(-10);
  return "";
}

export default function mapQuotationToCreateJobForm(apiResponse) {
  const q = apiResponse.quotation || apiResponse;
  const items = Array.isArray(apiResponse.items) ? apiResponse.items : [];

  const { first, last } = splitCustomerName(q.customerName);

  const totalQty =
    typeof q.totalQuantity === "number" && Number.isFinite(q.totalQuantity)
      ? q.totalQuantity
      : items.reduce((sum, it) => sum + (Number(it.quantity) || 0), 0);

  const lineSummaries = items
    .filter((it) => (it.itemName || "").trim())
    .map((it) => `${it.itemName} (qty ${it.quantity})`)
    .slice(0, 20);
  const notesExtra = q.notes ? String(q.notes) : "";

  const itemBlob = {
    prefilledFromQuotation: true,
    lines: lineSummaries,
    totalCft: q.totalCft,
    totalQuantity: totalQty,
    extraNotes: notesExtra,
  };

  return {
    consignorF: first,
    consignorL: last,
    consigneeF: first,
    consigneeL: last,
    contact: contactDigits10(q.phoneNumber),
    email: (q.email || "").trim(),
    oaddress1: q.originAddress1 || "",
    oaddress2: [q.originAddress2, q.companyName].filter(Boolean).join(" — ") || "",
    ocity: (q.originCity || "").trim() || "-",
    ostate: q.originState || "",
    opincode: q.originPincode || "",
    daddress1: q.destinationAddress1 || "",
    daddress2: q.destinationAddress2 || "",
    dcity: (q.destinationCity || "").trim() || "-",
    dstate: q.destinationState || "",
    dpincode: q.destinationPincode || "",
    items: totalQty || "",
    item: itemBlob,
    gst: q.companyName ? `Company: ${q.companyName}` : "",
  };
}
